import Vue from "vue";

export default {
	state: {
		standardListTypes: [],
		standardListCountry: [],
		standardListState: [],
		standardListCity: [],
		standardListBank: [],
		standardListAgency: [],
		standardListSupplier: []
	},
	mutations: {
		setStandardListTypeOnState(state, standardListTypes) {
			state.standardListTypes = standardListTypes;
		},
		setStandardListCountryOnState(state, standardList) {
			state.standardListCountry = standardList;
		},
		setStandardListStateOnState(state, standardList) {
			state.standardListState = standardList;
		},
		setStandardListCityOnState(state, standardList) {
			state.standardListCity = standardList;
		},
		setStandardListBankOnState(state, standardList) {
			state.standardListBank = standardList;
		},
		setStandardListAgencyOnState(state, standardList) {
			state.standardListAgency = standardList;
		},
		setStandardListSupplierOnState(state, standardList) {
			state.standardListSupplier = standardList;
		}
	},
	actions: {
		async getStandardListValue(_, filter) {
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get("standardList/filter", filter)
					.then((response) => {
						this.state.loading = false;
						resolve(response.data.data);
					})
					.catch(() => {
						this.state.loading = false;
						reject();
					});
			});
		},
		async getStandardListValueByType(_, type) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get(`standardList/type/${type}/values`)
					.then((response) => {
						resolve(response.data.data);
					})
					.catch((error) => {
						console.error(error);
						reject();
					})
					.finally(() => {
						this.state.loading = false;
					});
			});
		},
		async getStandardListTypes({ commit }) {
			this.state.loading = true;
			return new Promise((resolve, reject) => {
				Vue.prototype.$http
					.get(`standardList/typeList`)
					.then((response) => {
						commit("setStandardListTypeOnState", response.data.data);
						resolve(response.data.data);
					})
					.catch((error) => {
						console.error(error);
						reject();
					})
					.finally(() => {
						this.state.loading = false;
					});
			});
		}
	},
	getters: {
		standardListTypes({ standardListTypes }) {
			return standardListTypes;
		},
		standardListCountry({ standardListCountry }) {
			return standardListCountry;
		},
		standardListState({ standardListState }) {
			return standardListState;
		},
		standardListCity({ standardListCity }) {
			return standardListCity;
		},
		standardListBank({ standardListBank }) {
			return standardListBank;
		},
		standardListAgency({ standardListAgency }) {
			return standardListAgency;
		}
	}
};
